// extracted by mini-css-extract-plugin
export default {"accordionWrapper":"Accordion_accordionWrapper__eBuNt","header":"Accordion_header__Hf-Xn"};